import React, {useEffect, useRef, useState} from 'react';
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import Button from "../../../../../../components/button/button.jsx";
import {FaPlus, FaTrash} from "react-icons/fa";
import {useQuery} from "@tanstack/react-query";
import materialXStorageService from "../../../../../../services/web/material-x-storage-service.js";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import {AgGridReact} from "ag-grid-react";
import GenericEditRemoveCellRenderer from "../../../../../../components/ag-grid/generic-edit-remove-cell-renderer.jsx";
import {Modal} from "../../../../../../components/modal/modal.jsx";
import {Card} from "../../../../../../components/card/card.jsx";
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import {v4 as uuidv4} from "uuid";
import projectUtils from "../../../../../../utils/project-utils.js";

const initialData = () => ({
    itemId: uuidv4(),
    material: "",
    quantity: "",
    is_unique: false
});

const Material = ({materials, setMaterials, storage, setIsLoading}) => {
    const gridRef = useRef(null);
    const [openModal, setOpenModal] = useState(false)
    const [data, setData] = useState(initialData)
    const [columnDefs, setColumnDefs] = useState();

    const {data: materialsOptions, isSuccess, isLoading} = useQuery({
        queryKey: ['materials', storage],
        queryFn: async () => {
            if (storage) {
                return await materialXStorageService.optionsByStorage(storage, false)
            }

            return []
        },
        initialData: [],
    });

    useEffect(() => {
        setIsLoading(isLoading)
    }, [isLoading]);

    useEffect(() => {
        if (isSuccess) {
            setColumnDefs([
                {
                    headerName: "Material", field: "material_name", flex: 1,
                    valueFormatter: ({value, data}) => {
                        if (!value) {
                            const material = materialsOptions.find(m => m.value === data.material)
                            if (material) return material.label;

                            return null
                        }

                        return value;
                    }
                },
                {
                    headerName: "Quantidade",
                    width: 100,
                    valueGetter: ({data}) => data?.quantity ? Number(data.quantity) : null
                },
                {
                    headerName: "", field: "", width: 80,
                    cellRenderer: GenericEditRemoveCellRenderer,
                    cellRendererParams: {setData, setOpen:setOpenModal , remove}
                },
            ])
        }
    }, [materialsOptions, isSuccess]);


    const remove = (data) => {
        setMaterials(prevState => prevState.filter(p => p.itemId !== data.itemId))
    }

    const onChange = async (field, value) => {
        let isUnique = null;

        if (field === "material" && value) {
            setIsLoading(true)
            const { material } = await materialXStorageService.getById(value);
            isUnique = material.is_unique;
        }

        setData(prevState => {
            if (isUnique !== null) {
                prevState.is_unique = isUnique;

                if (isUnique) {
                    prevState.quantity = 1;
                }
            }

            return {...prevState, [field]: value}
        })

        setIsLoading(false)
    }

    const onHide = () => {
        setData(initialData)
        setOpenModal(false)
    }

    const save = () => {
        if (!data.material || !data.quantity) {
            let messageError = ""
            if (!data.quantity) messageError = "O campo \"Quantidade\" é obrigatório."
            if (!data.material) messageError = "O campo \"Material\" é obrigatório."

            projectUtils.swalErrorMessage("", messageError)
            return;
        }

        setMaterials(prevState => {
            const index = prevState.findIndex(p => p.itemId === data.itemId);

            if (index === -1) {
                return [...prevState, data];
            }

            const newState = [...prevState];
            newState[index] = data;

            return newState;
        });

        onHide()
    }

    return (
        <>
            <Card className={"mt-2"}>
                <Card.Header className={"gap-2"}>
                    <Card.Title>Materiais</Card.Title>
                    <Button className="h-7.5! w-7.5 !p-0" onClick={() => setOpenModal(true)}>
                        <FaPlus/>
                    </Button>
                </Card.Header>
                <Card.Body>
                    <AgGridReact
                        ref={gridRef}
                        rowData={materials}
                        columnDefs={columnDefs}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        theme={aggridUtils.generalTheme()}
                        domLayout='autoHeight'
                    />
                </Card.Body>
            </Card>

            <Modal isCloseClick={false} open={openModal} setOpen={onHide} centered size="md" backdrop="static" keyboard={false} overflow={true}
                   title={data.itemId ? "Editar material" : "Adicionar material"} className={"w-4/12"}>
                <Modal.Body className="p-2">
                    <SentryRow>
                        <div className="col-span-12">
                            <SelectComponent
                                name="material"
                                value={data.material || ""}
                                options={materialsOptions}
                                label={"Material/Grupo *"}
                                onChange={(selected) => onChange("material", selected?.value) }
                            />
                        </div>
                        <div className="col-span-12">
                            <InputForm
                                disabled={data.is_unique}
                                id={`quantity`}
                                type={"number"}
                                value={data.quantity || ""}
                                label="Quantidade *"
                                name={"quantity"}
                                onChange={(e) => onChange("quantity", e.target.value)}/>
                        </div>
                    </SentryRow>
                </Modal.Body>

                <Modal.Footer className={"p-1"}>
                    <div className={"w-full flex justify-end"}>
                        <Button onClick={save}>
                            Confirmar
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default Material;